import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {useSelector} from 'react-redux';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {ExceededModal, userSelector} from 'entities/user';
import {IncidentsScreen} from 'entities/monitor';
import useDomainIncidentsScreen from 'features/domain/model/useDomainIncidentsScreen';
import useDomainIncidentHeader from 'features/domain/model/useDomainIncidentHeader';
import {getDomainIncidentColumns} from 'features/domain/lib/domainIncidentHelper';

import CreateDomainMonitorButton from '../DomainMonitor/CreateDomainMonitorButton/CreateDomainMonitorButton';
import DomainMonitorModal from '../DomainMonitor/DomainMonitorModal';

import DomainIncidentRow from './DomainIncidentRow/DomainIncidentRow';
import DomainIncidentsFiltersModal from './DomainIncidentsFilters/DomainIncidentsFiltersModal';
import DomainIncidentsExportModal from './DomainIncidentsExport/DomainIncidentsExportModal';

const DomainIncidentsScreen: React.FC = () => {
    const {
        data, isLoading, isFetching, refetch, sort, setSort, plugState,
        openCreate, closeCreate, isCreateOpen, isExceededOpen,
    } = useDomainIncidentsScreen();
    const {
        search, onSearchSubmit, summary, isSummaryLoading, isSummaryError, refetchSummary,
    } = useDomainIncidentHeader();
    const user = useSelector(userSelector);

    return (
        <IncidentsScreen
            documentTitle={t`Инциденты доменов | Overseer`}
            title={i18n._(Pages.DOMAIN_INCIDENTS)}
            backUrl={AppUrls.DOMAIN_MONITORS}
            isFetching={isFetching}
            refetch={refetch}
            summary={{
                ...summary,
                isLoading: isSummaryLoading,
                isError: isSummaryError,
                refetch: refetchSummary,
            }}
            onSubmitSearch={onSearchSubmit}
            searchValue={search}
            renderFilterModal={(state) => <DomainIncidentsFiltersModal {...state}/>}
            renderExportModal={(state) => <DomainIncidentsExportModal {...state}/>}
            plugState={plugState}
            createButton={<CreateDomainMonitorButton onClick={openCreate}/>}
            createText={t`Добавить домен`}
            onCreate={openCreate}
            columns={getDomainIncidentColumns(false)}
            items={data?.items}
            rowFactory={(item) =>
                <DomainIncidentRow
                    key={item.id}
                    item={item}
                    tzString={user?.timezone}
                    hideDomain={false}
                />
            }
            isLoading={isLoading}
            pagination={data}
            sort={sort}
            setSort={setSort}
        >
            <DomainMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
            />

            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeCreate}
                type="domain_monitors"
            />
        </IncidentsScreen>
    );
};

export default DomainIncidentsScreen;
